import { render } from "./LabelOrder.vue?vue&type=template&id=d82335f8&scoped=true"
import script from "./LabelOrder.vue?vue&type=script&lang=js"
export * from "./LabelOrder.vue?vue&type=script&lang=js"

import "./LabelOrder.vue?vue&type=style&index=0&id=d82335f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d82335f8"]])

export default __exports__